import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { createBookmark, deleteBookmark } from "../actions";
import { bootstrapCompanyProjects, loadCompanyProjects } from "../../companies/actions";

type Project = WtdModels.Partial<WtdModels.Project, "id" | "bookmarked">;

export interface ProjectBookmarksState {
  [key: number]: boolean;
}

function initState(projects: Project[]) {
  return projects.reduce(
    (acc, project) => {
      acc[project.id] = project.bookmarked || false;
      return acc;
    },
    {} as ProjectBookmarksState
  );
}

const projectBookmarksReducer = withImmer(reducerWithInitialState<ProjectBookmarksState>({}))
  .cases([bootstrapCompanyProjects], (state, action) => {
    Object.assign(state, initState(action.projects));
    return state;
  })
  .cases([loadCompanyProjects.done], (state, action) => {
    Object.assign(state, initState(action.result.projects));
    return state;
  })
  .case(createBookmark.started, (state, projectId) => {
    state[projectId] = true;
    return state;
  })
  .case(createBookmark.failed, (state, action) => {
    const projectId = action.params;
    state[projectId] = false;
    return state;
  })
  .case(deleteBookmark.started, (state, projectId) => {
    state[projectId] = false;
    return state;
  })
  .case(deleteBookmark.failed, (state, action) => {
    const projectId = action.params;
    state[projectId] = true;
    return state;
  });

export default projectBookmarksReducer;



// WEBPACK FOOTER //
// ./frontend/src/project_bookmarks/reducers/index.ts